import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthModal from './AuthModal';

const Header = () => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <header className="fixed top-0 w-full z-50 bg-white/80 dark:bg-slate-950/80 backdrop-blur-xl shadow-[0_32px_48px_-12px_rgba(18,28,42,0.06)]">
        <nav className="flex justify-between items-center h-20 px-8 max-w-7xl mx-auto">
          <Link to="/" className="text-2xl font-bold tracking-tighter text-emerald-900 dark:text-emerald-50">
            Local Advisor
          </Link>
          
          <div className="hidden md:flex items-center gap-8 font-['Inter'] font-medium text-sm tracking-tight">
            <Link 
              to="/explore" 
              className={`${isActive('/explore') ? 'text-emerald-700 dark:text-emerald-400 font-semibold border-b-2 border-emerald-700 pb-1' : 'text-slate-600 dark:text-slate-400 hover:text-emerald-900 dark:hover:text-emerald-200 transition-colors'}`}
            >
              Explore
            </Link>
            <Link 
              to="/living" 
              className={`${isActive('/living') ? 'text-emerald-700 dark:text-emerald-400 font-semibold border-b-2 border-emerald-700 pb-1' : 'text-slate-600 dark:text-slate-400 hover:text-emerald-900 dark:hover:text-emerald-200 transition-colors'}`}
            >
              Living
            </Link>
            <Link 
              to="/housing" 
              className={`${isActive('/housing') ? 'text-emerald-700 dark:text-emerald-400 font-semibold border-b-2 border-emerald-700 pb-1' : 'text-slate-600 dark:text-slate-400 hover:text-emerald-900 dark:hover:text-emerald-200 transition-colors'}`}
            >
              Housing
            </Link>
            <Link 
              to="/jobs" 
              className={`${isActive('/jobs') ? 'text-emerald-700 dark:text-emerald-400 font-semibold border-b-2 border-emerald-700 pb-1' : 'text-slate-600 dark:text-slate-400 hover:text-emerald-900 dark:hover:text-emerald-200 transition-colors'}`}
            >
              Jobs
            </Link>
          </div>

          <div className="flex items-center gap-6">
            <div className="hidden lg:flex items-center bg-surface-container-low px-4 py-2 rounded-full shadow-sm">
              <span className="material-symbols-outlined text-on-surface-variant text-lg">search</span>
              <input 
                className="bg-transparent border-none focus:ring-0 text-sm w-48 font-body" 
                placeholder="Search neighborhood..." 
                type="text"
              />
            </div>
            
            {isAuthenticated ? (
              <div className="flex items-center gap-6">
                <Link to="/profile" className="flex items-center gap-3 group">
                  <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-700 group-hover:bg-emerald-700 group-hover:text-white transition-all overflow-hidden border border-emerald-200 shadow-sm">
                    {user?.avatar ? (
                      <img src={user.avatar} alt={user.full_name} className="w-full h-full object-cover" />
                    ) : (
                      <span className="material-symbols-outlined text-lg">person</span>
                    )}
                  </div>
                  <span className="text-sm font-semibold text-slate-700 group-hover:text-emerald-900 transition-colors">{user?.full_name}</span>
                </Link>
                <button 
                  onClick={handleLogout}
                  className="text-sm font-semibold text-slate-500 hover:text-red-600 transition-colors"
                >
                  Logout
                </button>
              </div>
            ) : (
              <button 
                onClick={() => setShowAuthModal(true)}
                className="bg-gradient-to-br from-primary to-primary-container text-on-primary px-8 py-2.5 rounded-full font-semibold text-sm hover:scale-105 active:scale-95 duration-200 ease-in-out shadow-lg shadow-primary/20"
              >
                Join
              </button>
            )}
          </div>
        </nav>
      </header>

      <AuthModal isOpen={showAuthModal} onClose={() => setShowAuthModal(false)} />
    </>
  );
};

export default Header;
